import reducer from './reducer'

import * as strategiesOperations from './operations'
import * as strategiesSelectors from './selectors'

export { strategiesOperations, strategiesSelectors }

export default reducer